import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "../live-seo-page.module.css";

type CareersLocalization = {
	title: string;
	heading: string;
	intro: string;
	resume: string;
	email: string;
};

const careersLocalization = {
	[Locale.EN]: {
		title: "Careers",
		heading: "Join Our Team",
		intro:
			"If you're an orthodontic or dental professional and looking to advance your career, Miami Orthodontic Specialists is accepting applications.",
		resume: "Send your resume to the email address below.",
		email: "smile@miamibraces.com",
	},
	[Locale.ES]: {
		title: "Carreras",
		heading: "Únete a nuestro equipo",
		intro:
			"Si eres profesional de ortodoncia o dental y buscas avanzar en tu carrera, Miami Orthodontic Specialists está aceptando solicitudes.",
		resume: "Envía tu currículum al correo electrónico a continuación.",
		email: "smile@miamibraces.com",
	},
} satisfies Record<Locale, CareersLocalization>;

export function CareersPage() {
	const getLocalization = useLocalization(careersLocalization);

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl="/careers-1.jpg"
				title={getLocalization("title")}
				backgroundPosition="top"
			/>
			<Box className={styles.careersBand}>
				<Box className={styles.careersInner}>
					<Heading as="h2" className={styles.careersHeading}>
						{getLocalization("heading")}
					</Heading>
					<Text as="p" size="4" className={styles.careersText}>
						{getLocalization("intro")}
					</Text>
					<Text as="p" size="4" className={styles.careersText}>
						{getLocalization("resume")}
					</Text>
					<a
						className={styles.careersEmailCta}
						href={`mailto:${getLocalization("email")}`}
					>
						{getLocalization("email")}
					</a>
				</Box>
			</Box>
			<Box className={styles.formWrap}>
				<HomeConsultForm />
			</Box>
		</Flex>
	);
}
